import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'

interface UpdateInvoiceStatusData {
	id: string
	status: string
}

export const getInvoices = createAsyncThunk('invoice/getInvoices',
  async (params: any) => {
		const paramText = new URLSearchParams(params)
		const url = `v1/invoices?${paramText}`
		const response: AxiosResponse<GeneralArrayResponse<Invoice>> = await instance.get(url)
    return response.data
  })

export const getInvoiceDetail = createAsyncThunk('invoice/getInvoiceDetail',
	async (id: string) => {
		const url = `v1/invoices/${id}`
		const response: AxiosResponse<Invoice> = await instance.get(url)
		return response.data
	})

export const updateInvoiceStatus = createAsyncThunk('invoice/updateInvoiceStatus',
	async (data: UpdateInvoiceStatusData) => {
		const { id, status } = data
		const url = `v1/invoices/${id}`
		const response: AxiosResponse<Invoice> = await instance.patch(url, { status })
		return response.data
	})

export const getRefundByInvoiceId = createAsyncThunk('invoice/getRefundByInvoiceId',
	async (params: any) => {
		const paramText = new URLSearchParams(params)
		const url = `v1/refunds?${paramText}`
		const response: AxiosResponse<GeneralArrayResponse<Refund>> = await instance.get(url)
		return response.data
	})
